// React Query client config — defaults fortes pra cache + retry.
import { QueryClient } from '@tanstack/react-query';

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,           // 30s — UI sente fresh por default
        gcTime: 5 * 60 * 1000,       // 5min em memória
        retry: 1,
        refetchOnWindowFocus: false, // admin não tem bursts
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
